import { Col, Collapse, Row, Table } from "antd";
import React, { useState, useEffect } from "react";
import { PersistedCollapse } from "../../../PersistedSections";
import { useParams } from "react-router-dom";
import { convertCentsIntoDollar, formatDate } from "../../../../helpers/genericHelper";
import API from "../../../../services/API";

export default function PlaidBalance({ plaidBalances }) {
  const { Panel } = Collapse;

  const columns = [
    {
      title: 'Plaid Account ID',
      dataIndex: 'plaidId',
      key: 'plaidId',
    },
    {
      title: 'Bank Name',
      dataIndex: 'bankName',
      key: 'bankName',
    },
    {
      title: 'Is Live Balance?',
      dataIndex: 'liveBalance',
      key: 'liveBalance',
      render: (liveBalance) => liveBalance ? "Yes" : "No"
    },
    {
      title: 'Balance',
      dataIndex: 'balanceInCents',
      key: 'balanceInCents',
      render: (text) => convertCentsIntoDollar(text),
    },
    {
      title: 'Recorded Time',
      dataIndex: 'recordedTime',
      key: 'recordedTime',
      render: (text) => formatDate(text, true),
      sorter: (a, b) => new Date(a.recordedTime).getTime() - new Date(b.recordedTime).getTime(),
    },
    {
      title: 'Charge Amount',
      dataIndex: 'achAmountInCents',
      key: 'achAmountInCents',
      render: (text) => convertCentsIntoDollar(text),
    }
  ];

  return (
    <Row style={{ marginLeft: 20, marginBottom: 20 }}>
      <Col xs={24} xl={24} sm={24} md={24}>
        <PersistedCollapse name="plaid-balance-section">
          <Panel header="Plaid Balance Entries" key="1">
            <Table
              dataSource={plaidBalances}
              columns={columns}
              rowKey="id"
              pagination={false}
            />
          </Panel>
        </PersistedCollapse>
      </Col>
    </Row>
  );
}
